<div>
  <div *ngFor="let item of data" class="mentions-list notification-list-item">
    <div class="comment-header-image"><div *ngIf="!item.user.picture" class="avatar-icon" [style]="'background-color:'+stringToHslColor(item.user.username) | safeStyle">{{item.user.username[0]}}</div><img class="avatar-icon" *ngIf="item.user.picture" [src]="item.user.picture | safe" onError="item.user.picture = ''" /></div>
    <div class="user-text">
      <div class="list-name"><strong>{{item.user.first_name}} {{item.user.last_name}}</strong> 
        {{'mentioned_you_in_comment'| translation}} <span class="mention-target">{{getCommentTitle(item)}}</span></div>
      <div class="list-title">{{item.time|date:'medium'}}</div>
      <div class="list-text" [innerHtml]="item.text | safeHtml">
      </div>
    </div>
    <button nbButton ghost status="info" (click)="open($event,item)"><span>{{'view'| translation}}</span><nb-icon pack="fas" icon="chevron-right"></nb-icon></button>
  </div>
</div>
<div *ngIf="data?.length == 0" class="list-empty-notification">
  {{'no_current_mentions'| translation}}
</div>


<!--  dont uncomment below-->
<!--
<div class="comment">
  <div class="comment-heading">
    <div class="comment-header-image"><div *ngIf="!comment.user.picture" class="avatar-icon" [style]="'background-color:'+color | safeStyle">{{comment.user.username[0]}}</div><img class="avatar-icon" *ngIf="comment.user.picture" [src]="comment.user.picture | safe" onError="comment.user.picture = ''" /></div>
    <div class="comment-header-button" [title]="!comment.resolved ? 'Mark as Resolved' : 'Reopen Comment'" (click)="resolve(comment)"><i class="fas fa-check" *ngIf="!comment.resolved"></i><i class="fas fa-box-open" *ngIf="comment.resolved"></i></div>
    <div class="comment-user">{{comment.user.username}}</div>
    <div class="comment-time">{{comment.time|date:'medium'}}</div>
  </div>
  <div class="comment-body">
    <div *ngIf="comment.selection">
      <div class="comment-selection-title">Comment Selection:</div>
      <div class="comment-selection-display" [innerHtml]="comment.selection | safeHtml"></div>
    </div>
    <div [innerHTML]="comment.text | safeHtml"></div>
  </div>
</div>-->
